// src/vue/index.ts
import { onBeforeUnmount, ref } from "vue";

// src/index.ts
var DEFAULT_DURATION_MS = {
  success: 3e3,
  info: 5e3,
  warning: 5e3
};
var state = {
  toasts: [],
  listeners: /* @__PURE__ */ new Set(),
  nextId: 0,
  autoDismissEnabled: true
};
var timerHandle = null;
function notify() {
  const snapshot = Object.freeze(state.toasts.slice());
  for (const listener of state.listeners) {
    listener(snapshot);
  }
}
function effectiveDismissMs(toast) {
  if (toast.sticky === true) return null;
  if (typeof toast.durationMs === "number") return toast.durationMs;
  if (toast.tone === "error") return null;
  return DEFAULT_DURATION_MS[toast.tone];
}
function armAutoDismiss(id) {
  const toast = state.toasts.find((t) => t.id === id);
  if (!toast) return;
  const dismissMs = effectiveDismissMs(toast);
  if (dismissMs === null) return;
  if (!state.autoDismissEnabled) return;
  if (typeof setTimeout !== "function") return;
  timerHandle = setTimeout(() => {
    timerHandle = null;
    dismissToast(id);
  }, dismissMs);
}
function pushToast(input) {
  const tone = input.tone ?? "info";
  const id = `toast-${state.nextId++}`;
  const toast = {
    id,
    tone,
    message: input.message,
    ...input.detail !== void 0 ? { detail: input.detail } : {},
    ...input.sticky !== void 0 ? { sticky: input.sticky } : {},
    ...input.durationMs !== void 0 ? { durationMs: input.durationMs } : {},
    pushedAt: Date.now()
  };
  state.toasts = [...state.toasts, toast];
  notify();
  armAutoDismiss(id);
  return id;
}
function dismissToast(id) {
  const before = state.toasts.length;
  state.toasts = state.toasts.filter((t) => t.id !== id);
  if (state.toasts.length === before) return;
  notify();
}
function dismissAllToasts() {
  if (state.toasts.length === 0) return;
  state.toasts = [];
  notify();
}
function getToasts() {
  return Object.freeze(state.toasts.slice());
}
function subscribeToasts(listener) {
  state.listeners.add(listener);
  listener(Object.freeze(state.toasts.slice()));
  return () => {
    state.listeners.delete(listener);
  };
}
function __resetToastStoreForTests() {
  state.toasts = [];
  state.listeners.clear();
  state.nextId = 0;
  state.autoDismissEnabled = true;
  if (timerHandle !== null && typeof clearTimeout === "function") {
    clearTimeout(timerHandle);
    timerHandle = null;
  }
}
function __getToastTimerForTests() {
  return timerHandle;
}

// src/vue/index.ts
var resetToastStoreForTests = __resetToastStoreForTests;
var getToastTimerForTests = __getToastTimerForTests;
function useToast() {
  const toasts = ref(getToasts());
  const unsubscribe = subscribeToasts((snapshot) => {
    toasts.value = snapshot;
  });
  onBeforeUnmount(() => {
    unsubscribe();
  });
  return {
    push: pushToast,
    dismiss: dismissToast,
    dismissAll: dismissAllToasts,
    toasts
  };
}
export {
  getToastTimerForTests,
  getToasts,
  resetToastStoreForTests,
  useToast
};
//# sourceMappingURL=index.js.map